<div fxLayout="column">
    <div fxFlex="1 1 auto" class='dashboard-metric-type'>
        <span>{{dashboardMetricSet.label}}</span>
    </div>
    <div fxFlex="1 1 auto" fxLayout="row">
        <div class="metric-holder" *ngIf="!dashboardMetricSet.subType" fxFlex="1 1 auto">
            <div fxLayout="row">
                <span fxFlex="1 1 auto" class="dashboard-metric-value dashboard-metric-center" fontsize ="1em">{{dashboardMetricSet.values[0] || '--'}}</span>
                <!-- <span fxFlex="1 1 5%" [ngClass]="'dashboard-metric-center-icon fa fa-' + riskMetric.centerIcon"></span> -->
            </div>
        </div>
        <div class="metric-holder" *ngIf="dashboardMetricSet.subType" fxFlex="1 1 auto">
            <div fxLayout="row">
                <span fxFlex="1 1 auto" class="subtype-dashboard-metric-value dashboard-metric-center" fontsize ="1em">{{dashboardMetricSet.values[0] || '--'}}</span>
                <!-- <span fxFlex="1 1 5%" [ngClass]="'dashboard-metric-center-icon fa fa-' + riskMetric.centerIcon"></span> -->
            </div>
        </div>
    </div>
</div>